<template lang="pug">
  div.mt-2
    .list-mobile
      planning-table-row-mobile(
        v-for="item in schedules"
        :key="item.id"
        :item="item")

</template>

<script>
import PlanningTableRowMobile from './PlanningTableRowMobile'

export default {
  name: 'PlanningTableMobile',

  components: {
    PlanningTableRowMobile
  },

  props: {
    schedules: {
      type: Array,
      required: true
    }
  }
}
</script>
